import React from 'react';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
import { situations } from '../data/situations';
export function SituationsSection() {
  return <section className="w-full bg-white px-5 py-16 sm:py-20" data-id="element-278" data-mp="2nksbjx7zcwbi">
      <div className="mx-auto max-w-5xl" data-id="element-279" data-mp="2nn50wvg2i8yl">
        <SectionHeading title={<>
              Do any of these situations <span className="text-electric-600" data-id="element-281" data-mp="2dmma1gq35s76">sound familiar?</span>
            </>} subtitle="If you recognize even one of these situations, I created this system with technicians like you in mind." data-id="element-280" data-mp="2imgzdfu7q9q4" />

        <ul className="mt-10 grid gap-x-10 gap-y-7 md:grid-cols-2" data-id="element-282" data-mp="24vlv6gunsgsv">
          {situations.map(({
          icon: Icon,
          title,
          text
        }) => <li key={title} className="flex gap-4" data-id="element-283" data-mp="1ztd27khsdeqr">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-navy-900" data-id="element-284" data-mp="1uwmov4xd8x91">
                <Icon className="h-6 w-6 text-gold-400" aria-hidden="true" data-id="element-285" data-mp="1pybduqvc4gp8" />
              </span>
              <div data-id="element-286" data-mp="2xv3e1q0m8su">
                <h3 className="text-[17px] font-bold leading-snug text-ink" data-id="element-287" data-mp="2xbo6srr1yii">{title}</h3>
                <p className="mt-1.5 text-[15px] leading-relaxed text-muted" data-id="element-288" data-mp="7qegyyopd3xn">{text}</p>
              </div>
            </li>)}
        </ul>

        <div className="mx-auto mt-14 max-w-2xl rounded-3xl bg-navy-900 px-6 py-8 text-center text-white sm:px-10" data-id="element-289" data-mp="3u57blr8x7bwm">
          <p className="text-[17px] leading-relaxed text-slate-300" data-id="element-290" data-mp="louo2qqh8wgb">
            And it shouldn't have to be this difficult. I've learned something important while working on this system:
          </p>
          <p className="mt-4 font-display text-[30px] font-extrabold uppercase leading-tight text-gold-400" data-id="element-291" data-mp="brq0cmgzgsxe">
            More information doesn't automatically lead to better decisions.
          </p>
          <p className="mt-4 text-[16px] leading-relaxed text-slate-300" data-id="element-292" data-mp="2wgxik1r43yhn">
            Without a process for organizing that information, you may still find yourself asking:
          </p>
          <p className="mt-3 text-xl font-semibold italic text-white" data-id="element-293" data-mp="17xjn1wms2ujh">“Okay… what should I check next?”</p>
        </div>

        <CtaButton label="I want a clear diagnostic process" className="mt-10" data-id="element-294" data-mp="12yggg7r5gg9e" />
      </div>
    </section>;
}